import { Link } from "react-router-dom";
import SectionHeading from "@/components/ui/Section";

const QUOTES = [
  {
    quote:
      "在这里读懂的不只是谁红谁糊，更是这个圈子如何一点点运转起来。每篇都有来源标注，很安心。",
    name: "晚风电台",
    role: "资深吃瓜人 · 读者",
    icon: "ri-double-quotes-l",
  },
  {
    quote:
      "作为匿名的圈内人，我愿意把一些能说的行业观察放在这里。至少这里不会拿着真名去过度演绎。",
    name: "匿名的统筹",
    role: "剧组统筹 · 信源之一",
    icon: "ri-eye-off-line",
  },
  {
    quote:
      "从剧组盒饭到档期表，角度很真实，没有为了流量硬造噱头，能看出是真的有人懂行。",
    name: "桃桃乌龙",
    role: "每日追更读者",
    icon: "ri-double-quotes-l",
  },
];

export default function Voices() {
  return (
    <section className="container-page mt-14 md:mt-20">
      <SectionHeading
        kicker="Word of Mouth"
        title="读者口碑 & 信源背书"
        desc="我们把「少一点恶意造谣，多一点有依据的圈内观察」当作底线。听听读者与匿名信源怎么评价我们。"
      />
      <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
        {QUOTES.map((q) => (
          <figure
            key={q.name}
            className="flex flex-col rounded-lg border border-background-200 bg-background-100 p-6"
          >
            <span className="inline-flex h-9 w-9 items-center justify-center rounded-md bg-accent-100 text-lg text-accent-700">
              <i className={q.icon}></i>
            </span>
            <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-800">
              {q.quote}
            </blockquote>
            <figcaption className="mt-5 border-t border-background-200 pt-3">
              <p className="font-heading text-sm font-bold text-foreground-950">
                {q.name}
              </p>
              <p className="text-xs text-foreground-500">{q.role}</p>
            </figcaption>
          </figure>
        ))}
      </div>
      <div className="mt-6 flex flex-col items-start justify-between gap-4 rounded-lg bg-secondary-100 px-6 py-5 sm:flex-row sm:items-center">
        <div className="flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-200 text-secondary-900">
            <i className="ri-team-line text-lg"></i>
          </span>
          <p className="text-sm text-foreground-800">
            好奇我们是谁、信源从哪里来、为什么坚持匿名？读读我们的品牌故事与信源原则。
          </p>
        </div>
        <Link
          to="/about"
          className="c-btn shrink-0 bg-secondary-500 text-background-50 hover:bg-secondary-600"
        >
          关于我们
          <i className="ri-arrow-right-line ml-1.5"></i>
        </Link>
      </div>
    </section>
  );
}